import {InformationCircleIcon} from "@heroicons/react/24/outline";
import {useAuth} from "../../hooks/useAuth.tsx";

const AccountLogoutEverywhere = () => {
    const _authService = useAuth();
    const handleLogoutEverywhereClick = async () => {
        await _authService.logoutFromAllDevices();
    }
    return (
        <div>
            <h2 className={"text-xl"}>Wyloguj ze wszystkich urządzeń</h2>
            <div className={"flex items-center space-x-3 my-4 text-neutral-400"}>
                <p className={"text-sm"}>Dzięki tej opcji możesz wylogować się z serwisu BM GO na wszystkich
                    przeglądarkach i urządzeniach jednocześnie – również na tym, którego teraz używasz.</p>
                <InformationCircleIcon className={"w-7 h-7 shrink-0"}/>
            </div>
            <button
                className={`text-neutral-200 rounded-full px-5 py-1.5 transition bg-neutral-600 hover:bg-neutral-700`}
                onClick={async () => {
                    await handleLogoutEverywhereClick();
                }}>
                Wyloguj wszędzie
            </button>
        </div>
    );
};

export default AccountLogoutEverywhere;